import {useEffect, useRef} from 'react';

export const useOnMount = (func?: VoidFunction) => {
  const didMountRef = useRef(false);

  // eslint-disable-next-line eag/no-effect-without-cleanup
  useEffect(() => {
    if (didMountRef.current === false) {
      func?.();
      didMountRef.current = true;
    }
  }, []);
};
